import instance from "./request";

// 获取验证码请求
export const GetCaptchaCodeApi = () => instance.get("/api/captchaImage")

// 登录请求
export const LoginApi = (params) => instance.post("/admin/login", params)

// 获取路由请求
export const GetUserRoutersApi = () => instance.get("/admin/getRouters")

// 获取用户信息
export const GetUserInfoApi = () => instance.get("/admin/getInfo")

// 获取通知
export const GetNoticeApi = (params) => instance.get("/admin/getNotice", params)
// 发布通知
export const SubmitNoticeApi = (params) => instance.post("/admin/notice/update", params)

// 用户查询
export const GetUsersApi = (params) => instance.get("/admin/getUsers", params)
// 充值
export const UserChargeApi = (params) => instance.post("/admin/user/charge", params)
// 扣减
export const UserCutApi = (params) => instance.post("/admin/user/cut", params)
// 充值
export const UserChangeTermApi = (params) => instance.post("/admin/user/changeTerm", params)
// 注销
export const UserDelApi = (params) => instance.post("/admin/user/del", params)
// 解绑
export const UserUnbindApi = (params) => instance.post("/admin/user/unbind", params)
// 修改密码
export const UserChangePwdApi = (params) => instance.post("/admin/user/changePwd", params)
// 注册
export const UserRegisterPwdApi = (params) => instance.post("/admin/user/register", params)
// 获取公告
export const GetGonggaoApi = (params) => instance.get("/admin/getGonggao", params)
// 发布公告
export const SubmitGonggaoApi = (params) => instance.post("/admin/gonggao/update", params)
// 导出所有uk
export const GetUksApi = () => instance.get("/admin/getUks")
// 生成卡密
export const CodeCreateApi = (params) => instance.post("/admin/code/create", params)
// 查询卡密
export const GetCodeApi = (params) => instance.get("/admin/getCode", params)
// 修改批量查询限制
export const ChangeLimitApi = (params) => instance.post("/admin/changeLimit", params)
// 批量添加库存黑名单
export const AddBlackApi = (params) => instance.post("/admin/addBlack", params)
// 批量删除库存黑名单
export const DelBlackApi = (params) => instance.post("/admin/delBlack", params)
// 批量添加定制库存
export const AddCustomApi = (params) => instance.post("/admin/addCustom", params)
// 批量删除定制库存
export const DelCustomApi = (params) => instance.post("/admin/delCustom", params)
// 获取网页版通知
export const GetWebNoticeApi = () => instance.get("/admin/getNotice/web")
// 发布网页版通知
export const SubmitWebNoticeApi = (params) => instance.post("/admin/notice/update/web", params)
// 查询链接记录
export const GetLinksApi = (params) => instance.get("/admin/getLinks", params)
// 删除链接记录
export const DelLinkApi = (params) => instance.post("/admin/delLink", params)
export const DelLinksApi = () => instance.post("/admin/delLinks")